export const LOGIN_BASE = 'base'
export const LOGIN_KEYCLOAK = 'keycloak'
export const LOGIN_KEYCLOAK_OAUTH2 = 'keycloakOauth2'
